import type { DictionaryType } from 'types/story';
import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { getText } from 'utils/dictionary';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Fields/Select/Select';
import { FieldBBErrorType, SelectBBOptionsOrder } from '../constants';

type Props = {
	dictionary?: DictionaryType;
};

export const SELECT = ({ dictionary = {} }: Props = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.SELECT;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: SELECT.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
						[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
					},

					componentProps: {
						[UNIFORM_PROPS.selectOptions]: [
							{ label: 'Option 1', value: '1' },
							{ label: 'Option 2', value: '2' },
						],
						[UNIFORM_PROPS.selectOptionsOrder]: SelectBBOptionsOrder.alphabet,
						[UNIFORM_PROPS.selectIsMulti]: false,
						[UNIFORM_PROPS.fieldPlaceholder]: getText(dictionary, type, 'fieldPlaceholder'),
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
								},
							},
						},
						other: {},
					},
					nodeProps: { id: generateNodeId(_id, SELECT.displayName) },
				},
				children: [],
			};
		},
	};
};

SELECT.displayName = 'Select';
